'use client';

import dynamic from 'next/dynamic';

// Loaded client-only: NextTopLoader renders a raw <style> element whose
// placement differs between SSR and client hydration in React 19, which
// produces a body-level hydration mismatch. There is nothing to display
// before the first client navigation, so skipping SSR is free.
const NextTopLoader = dynamic(() => import('nextjs-toploader'), {
  ssr: false
});

export function TopLoader() {
  return <NextTopLoader showSpinner={false} />;
}
